import { Trophy } from "lucide-react";
import { GameLabel } from "./TeamLogo";

export const BEST_LEVEL = 65;
const avg = (xs) => (xs.length ? xs.reduce((a, b) => a + b, 0) / xs.length : 0);

export const legChance = (l) => {
  const parts = [l.market_pct];
  if (l.trend_confidence != null) parts.push(l.trend_agree ? l.trend_confidence : 100 - l.trend_confidence);
  if (l.hit_rate != null) parts.push(l.hit_rate);
  return avg(parts.filter((x) => x != null));
};

export const rankGames = (legs) => {
  const by = {};
  legs.forEach((l) => (by[l.matchup_id] ||= { id: l.matchup_id, sport: l.sport, label: l.game_label, legs: [] }).legs.push(l));
  return Object.values(by)
    .map((g) => ({ ...g, chance: Math.round(avg(g.legs.map(legChance))), market: Math.round(avg(g.legs.map((l) => l.market_pct))) }))
    .sort((a, b) => b.chance - a.chance);
};

export const BestGames = ({ games }) => {
  if (!games.length) return null;
  return (
    <div data-testid="best-games" className="rounded-xl border border-[#233248] bg-[#0B0F17]/60 p-3">
      <div className="flex items-center gap-2 mb-2">
        <Trophy className="h-4 w-4 text-[#F59E0B]" />
        <span className="font-heading font-bold text-white text-sm">Best winning chance by game</span>
        <span className="text-[10px] text-slate-500 font-data">highlighted ≥ {BEST_LEVEL}%</span>
      </div>
      <div className="space-y-1.5">
        {games.map((g) => {
          const best = g.chance >= BEST_LEVEL;
          return (
            <div key={g.id} data-testid={`best-game-${g.id}`} data-best={best}
              className={`flex items-center gap-2 rounded-lg px-2.5 py-1.5 border ${
                best ? "border-[#F59E0B]/60 bg-[#F59E0B]/10 shadow-[0_0_12px_rgba(245,158,11,0.25)]" : "border-transparent bg-[#141C2B]"}`}>
              {best && <Trophy data-testid={`best-game-badge-${g.id}`} className="h-3.5 w-3.5 text-[#F59E0B] shrink-0" />}
              <GameLabel sport={g.sport} label={g.label} size="xs" className="text-[11px] min-w-0 flex-1 truncate" />
              <span className="font-data text-[10px] text-slate-400 whitespace-nowrap">{g.legs.length} legs · mkt {g.market}%</span>
              <span className={`font-data text-xs font-bold whitespace-nowrap ${best ? "text-[#F59E0B]" : "text-slate-300"}`}>{g.chance}%</span>
            </div>
          );
        })}
      </div>
      <p className="text-[10px] text-slate-500 font-data mt-1.5">Win chance = average of AI + Market %, AI trend confidence and recent hit rate across the game's legs</p>
    </div>
  );
};
